import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { NaturalDisturbanceCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface NaturalDisturbanceCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const NaturalDisturbanceCell = ({
  value,
  task,
  selectedField,
  year,
  onSaveSuccess,
}: NaturalDisturbanceCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="naturalDisturbance"
      onSaveSuccess={onSaveSuccess}
    >
      <NaturalDisturbanceCellDisplay value={value} />
    </TraitCellContainer>
  )
}
